import React,{useRef,useEffect} from 'react';  
import ReactDom from 'react-dom';
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'
  import {Link } from 'react-router-dom'
import LazyLoad from 'react-lazy-load';

  function HomePageCell(props){
    return <Grid.Column style={{paddingBottom:'5em', paddingTop:'5em'}}>
    <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
      {props.title}
    </Header>
    <p style={{fontSize:'1.33em'}}>
      {props.body}
    </p> 
    <Link to={props.destination}> 
      <Button color={"blue"} content={"Check out Gifs"} ></Button>
    </Link>
    <LazyLoad height={10}>
      <div></div>
      </LazyLoad> 
    <LazyLoad height = {170}> 
      <img src={props.minigif} style={{"borderStyle":'inset', 'borderColor':'#000000'}} border="1"/> 
    </LazyLoad>
  </Grid.Column>
  }

  
export default HomePageCell;